import { SvgIcon, } from "@material-ui/core";

import { HomeTwoTone as HomeIcon } from "@material-ui/icons";
import { Help as HelpIcon } from "@material-ui/icons";
import { ReactComponent as PodiumIcon } from "../assets/icons/podium.svg";
import { ReactComponent as RoseIcon } from "../assets/icons/rose-flower-outlined.svg";

export const HOME = "HOME";
export const STANDINGS = "STANDINGS";
export const RANKS = "RANKS";
export const SEASON_PREDICTIONS = "SEASON PREDICTIONS";
export const WEEKLY_PREDICTIONS = "WEEKLY PREDICTIONS";
export const USER_ENTRIES = "USER ENTRIES";
export const MY_ENTRY = "MY ENTRY";
export const SEASONS = "SEASONS";
export const ADMIN = "ADMIN";
export const FAQS = "FAQS";
export const USER_PAGE = "USER PAGE";

const routes = {
  [HOME]: {
    path: "/",
    name: "Home",
    sidebarName: "Home",
    icon: <HomeIcon />,
  },
  [STANDINGS]: {
    path: "/",
    name: "Standings",
    sidebarName: "Standings",
    icon: <SvgIcon component={PodiumIcon} viewBox="0 0 512 512"/>,
  },
  [RANKS]: {
    path: "/rankings",
    name: "Rankings",
    sidebarName: "Contestant Rankings",
  },
  [SEASON_PREDICTIONS]: {
    path: "/season-predictions",
    name: "Season Predictions",
    sidebarName: "Season Predictions",
  },
  [USER_ENTRIES]: {
    path: "/user-entries/:userEntryId",
    pathWithoutParam: "/user-entries/",
    name: "My Entry",
    sidebarName: "My Entry",
    icon: <SvgIcon component={RoseIcon} htmlColor="white" viewBox="0 0 512 512"/>,
  },
  [MY_ENTRY]: {
    path: "/my-entry",
    name: "My Entry",
    sidebarName: "My Entry",
    icon: <SvgIcon component={RoseIcon} htmlColor="white" viewBox="0 0 512 512"/>,
  },
  [WEEKLY_PREDICTIONS]: {
    path: "/weekly-predictions",
    name: "Weekly Predictions",
    sidebarName: "Weekly Predictions",
  },
  [SEASONS]: {
    path: "/seasons/:seasonId",
    pathWithoutParam: "/seasons/",
    name: "Seasons",
    sidebarName: "Seasons",
  },
  [ADMIN]: {
    path: "/admin",
    name: "Admin",
    sidebarName: "Admin",
  },
  [FAQS]: {
    path: "/faqs",
    name: "FAQs",
    sidebarName: "FAQs",
    icon: <HelpIcon />,
  },
  [USER_PAGE]: {
    path: "/users/:userId",
    pathWithoutParam: "/users/",
    name: "User",
  },
};

export default routes;